import React from 'react';

import { IconButton, Typography, useTheme } from '@mui/joy';

import Button from 'components/core/Button';
import Stack from 'components/core/Stack';
import Card from 'components/core/Card';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import CriterionDialog from './CriterionDialog';

import Observation from 'domain/Observation';

const blankCriterion = {
    field: null,
    operator: null,
    value: null,
};

const QueryBuilder = ({
    criteria,
    setCriteria,
    observationOptions,
    personList
}) => {
    const theme = useTheme();
    const [currentCriterionIndex, setCurrentCriterionIndex] = React.useState(null);

    const addCriterion = () => {
        setCriteria([...criteria, blankCriterion]);
        selectCriterion(criteria.length);
    }

    const removeCriterion = (index) => {
        setCriteria(criteria.filter((_, i) => i !== index));
    }

    const selectCriterion = (index) => {
        setCurrentCriterionIndex(index);
    }

    const updateCriterion = (newCriterion) => {
        const newCriteria = [...criteria];
        newCriteria[currentCriterionIndex] = newCriterion
        setCriteria(newCriteria);
        setCurrentCriterionIndex(null);
    }

    const unselectCriterion = () => {
        const currentCriterion = {...criteria[currentCriterionIndex]};
        if (!currentCriterion.field || !currentCriterion.operator || !currentCriterion.value) {
            removeCriterion(currentCriterionIndex);
        }
        setCurrentCriterionIndex(null);
    }

    const criterionValueLabel = (criterion) => {
        const criterionFieldSchema = Observation.FIELDS.find(f => f.field === criterion.field);
        if (criterionFieldSchema?.type === 'Boolean') {
            return criterion.value ? 'Yes' : 'No';
        }
        if (!criterionFieldSchema || !criterion.value) {
            return null
        }

        if (criterionFieldSchema?.type?.type === 'Pointer') {
            if (criterionFieldSchema?.type?.targetClass === 'Name' || criterionFieldSchema?.type?.targetClass === 'Event') {
                return criterion?.value?.get('name') || '';
            } else if (criterionFieldSchema?.type?.targetClass === 'Person') {
                return criterion?.value?.get('name') || '';
            } else {
                return criterion?.value?.get('label') || '';
            }
        }
        return criterion.value
    }

    const criterionBox = (criterion, index) => {
        const fieldSchmea = Observation.FIELDS.find(f => f.field === criterion.field);
        return (
            <Card
                onClick={() => selectCriterion(index)}
                sx={{
                    cursor: 'pointer',
                    backgroundColor: theme.palette.primary['solidBg'],
                    color: 'white',
                    paddingTop: 0.5,
                    paddingBottom: 0.5,
                    display: "flex",
                    alignItems: "center",
                    height: 'fit-content'

                }}
            >
                <Stack direction="row" alignItems="center">
                    <Typography sx={{ color: 'white' }}>
                        {`${fieldSchmea?.label || ''} ${criterion.operator} ${criterionValueLabel(criterion)}`}
                    </Typography>
                    <IconButton onClick={() => removeCriterion(index)}>
                        <CloseIcon sx={{ color: 'white' }} />
                    </IconButton>
                </Stack>
            </Card>
        )
    }

    if (criteria.length === 0) {
        return (
            <>
                <Button
                    sx={{
                        width: '200px',
                    }}
                    onClick={addCriterion}
                >
                    <AddIcon/> Add Criteria
                </Button>
            </>
        )
    }

    return (
        <>
            <CriterionDialog
                criterion={criteria[currentCriterionIndex]}
                currentCriterionIndex={currentCriterionIndex}
                fieldOptions={Observation.FIELDS}
                onClose={unselectCriterion}
                onUpdateCriterion={updateCriterion}
                observationOptions={observationOptions}
                personList={personList}
            />
            <Stack direction="row" spacing={2}  alignItems="center">
                {criteria.map((criterion, index) => (
                    criterionBox(criterion, index)
                ))}
                <Button
                    sx={{
                        width: '200px'
                    }}
                    onClick={addCriterion}
                    variant="outlined"
                >
                    <AddIcon/> Add Criteria
                </Button>
            </Stack>
        </>
    );
}

export default QueryBuilder;